require("./jquery-ui-autocomplete.min.js");
window.fundCharts = {
    FundSet: [],
    Ticker: "",
    InceptionDate: "",
    rowData: "",

    init: function () {
        viewportWideSpinner.init();
        feutils.spinner.init();
        feutils.spinner.load();
        feutils.spinner.hide();

        //check if tkr is there...
        fundCharts.Ticker = fundCharts.getParameterByName("tkr");
        if (typeof fundCharts.Ticker === "undefined") return console.log("Could not get Ticker from Query String!");

        console.log("Ticker is: " + fundCharts.Ticker);
        fundCharts.getInceptionDate(fundCharts.Ticker);

    },

    getInceptionDate: function (ticker) {
        url = "/Main/FundListingUs/GetFundData";

        txdata = {
            'filterJson':
                '{"InvType":"","AssetClass":[],"Funds":[],"ShareClass":[],"TableType":"tickers","CurrentPageId":"5517","ChartTicker":"' + ticker + '"}'
        }

        console.log(txdata);

        feutils.spinner.show();
        console.time('Ajax load');

        $.post(url, txdata).done(function (data, response) {

            feutils.spinner.hide();
            console.timeEnd('Ajax load');

            //we are getting all of the funds and saving to object level variable.
            fundCharts.FundSet = data.Result.FundSet;

            //find the fund that matches the ticker
            var theFund = fundCharts.FundSet.find(function(fund) {
                if (typeof fund.FundID != "string") return false;
                return fund.FundID.toUpperCase() === ticker.toUpperCase();
            });
            if (typeof theFund === "undefined") {
                console.error("Could not Find the Fund!");
                window.location.href = "/";
            }

            //return the inception date
            fundCharts.InceptionDate = theFund.InceptionDate;

            //get the Fund Type
            var fundType = theFund.FundType || false;

            fundCharts.startRenderChart(fundCharts.InceptionDate, theFund.FundID, fundType, theFund.IndexDisplayTicker, data.Result.ChartDownloadUrl);


        }).fail(function (err) {
            console.log(err);
            return false;
        });

    },


    startRenderChart: function (inceptionDate, Ticker, tickerGroup, displayTicker, downloadUrl) {
        //Sometimes the display ticker is slightly different from the actual Ticker.
        displayTicker = displayTicker || Ticker;

        //This function is supposed to render the chart...
        console.log("Ticker: " + Ticker + ", Inception Date: " + inceptionDate + ", Display Ticker:" + displayTicker);
        if (typeof tickerGroup != "string") {
            var title = "Nav Chart";
        } else {
            var title = (tickerGroup.toLowerCase() === "index") ? "Price Chart" : "Nav Chart";
        }

        $(".f-code").append(displayTicker + " - " + title);

        //create the RowData
        fundCharts.rowData = {
            ExpandableContent: {
                Ticker: Ticker,
                InceptionDate: inceptionDate,
                DownloadUrl: downloadUrl
            }
        }

        var generatedHTML = feCharts.rnChartArea("price", fundCharts.rowData, tickerGroup, displayTicker);

        /*
	        Append it to the container
        */
        $("#rendering-container").append(generatedHTML);

        var today = new Date;
        today = today.toISOString().slice(0, 10);

        feCharts.loadData("#the-tab-" + Ticker, Ticker, "price", false, inceptionDate, today);

        /*
        window.loadEvents()

        This is from the scripts.js, we are reloading all the listners.
        */
        window.loadEvents();

    },


    getParameterByName: function (name) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(window.location.href);
        if (!results) return null;
        if (!results[2]) return '';
        var f_code = decodeURIComponent(results[2].replace(/\+/g, ' '))
        var cnv_f_code = f_code;//.toUpperCase();
        return cnv_f_code;
    }
}


/*
 * Common utilities used above.
 */
window.feutils = {
    spinner: {
        init: function () {
            $("#veSpinnerContainer").append('<div id="loading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
            $("#veLoginSpinnerContainer").append('<div id="loginloading"><div id="loadingcontent"><p id="loadingspinner"></p></div></div>');
            //$('#viewport-wide-spinner').hide();
            feutils.spinner.theSpinner = feutils.spinner.load();
        },
        load: function () {

            eventType = "blur";
            id = "loading";

            //If want to change the text below the spinning div.
            //if (progressText != undefined) { $("#loadingspinner").html(progressText); }
            $('#loading').fadeIn();
            var opts = {
                lines: 12, // The number of lines to draw
                length: 7, // The length of each line
                width: 4, // The line thickness
                radius: 10, // The radius of the inner circle
                color: '#000', // #rgb or #rrggbb
                speed: 1, // Rounds per second
                trail: 60, // Afterglow percentage
                shadow: false, // Whether to render a shadow
                hwaccel: false // Whether to use hardware acceleration
            };
            var target = document.getElementById('loading');
            var spinner = new Spinner(opts).spin(target);

            return spinner;
        },
        hide: function () { $('#viewport-wide-spinner').hide(); },
        show: function () { $('#viewport-wide-spinner').show(); }


    }
}

window.addEventListener("DOMContentLoaded", fundCharts.init);